// Layout.jsx
import React, { useEffect, useRef, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import BlogcardSection from "../BlogSection/BlogcardSection";
import CertificateCard from "../CertificateCard/CertificateCard";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Contactus = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });
  const faqRef = useRef(null); // Create a reference for the FAQList component
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0); // Ensure the page scrolls to the top on reload
    if (window.location.hash) {
      // Remove any hash in the URL
      window.history.replaceState(null, null, " ");
    }
  }, []);

  const scrollToFAQ = () => {
    faqRef.current?.scrollIntoView({ behavior: "smooth" }); // Scroll to FAQList component
  };

  const handleToggle = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSubmit = async () => {
    try {
      console.log("formData:======>>>", formData);
      //   const response = await fetch("http://localhost:5000/api/contact", {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify(formData),
      //   });

      //   const result = await response.json();
      //   if (response.ok) {
      //     alert("Form submitted successfully!");
      //     setFormData({
      //       name: "",
      //       email: "",
      //       phone: "",
      //       company: "",
      //       message: "",
      //     });
      //   } else {
      //     alert("Failed to submit: " + result.message);
      //   }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting form");
    }
  };

  return (
    <>
      <Header />
      <main>
        {/* contact us component */}

        {/* Google Map  21.2070° N, 81.3260° E */}
        <Stack
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack
            sx={{
              width: {
                xl: "72%",
                lg: "80%",
                md: "90%",
                sm: "96%",
                xs: "100%",
              },
              height: "400px",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <iframe
              title="Google Map"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=21.2070,81.3260&z=15&output=embed"
            />
          </Stack>

          <Stack
            sx={{
              width: {
                xl: "72%",
                lg: "80%",
                md: "90%",
                sm: "96%",
                xs: "100%",
              },
              marginTop: "40px",
              display: "flex",
              flexDirection: {
                xl: "row",
                lg: "row",
                md: "row",
                sm: "row",
                xs: "column",
              },
            }}
          >
            <Stack
              sx={{
                width: { sm: "50%", xs: "100%" },
                marginBottom: "40px",
              }}
            >
              <Stack sx={{ gap: 2 }}>
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    marginLeft: { xs: "16px", sm: "0px" },
                  }}
                >
                  <Stack
                    sx={{
                      fontSize: {
                        xl: "20px",
                        lg: "20px",
                        sm: "20px",
                        xs: "16px",
                      },
                      fontWeight: 400,
                      color: "var(--color-gray-400)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    INFORMATION QUESTIONS
                  </Stack>
                  <Stack
                    sx={{
                      fontSize: {
                        xl: "20px",
                        lg: "20px",
                        sm: "20px",
                        xs: "16px",
                      },
                      fontWeight: 600,
                      color: "rgb(0, 0, 0)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    FREQUENTLY ASKED QUESTIONS
                  </Stack>
                </Stack>
                <Stack>
                  <Accordion
                    expanded={expanded === "panel1"}
                    onChange={handleToggle("panel1")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel1" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel1" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        What is WhatsApp Business API?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        WhatsApp Business API enables businesses to automate
                        customer communication, send notificationsand provide
                        a personalized experience at scale using WhatsApp.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel5"}
                    onChange={handleToggle("panel5")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel5" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel5" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel5a-content"
                      id="panel5a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Can I use my existing WhatsApp number?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        No, you need a phone number that is not already linked
                        to a personal or business WhatsApp account.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel3"}
                    onChange={handleToggle("panel3")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel3" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel3" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Can businesses of all sizes use the WhatsApp Business
                        API?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Yes, businesses of all sizes can use it. However, it is
                        best suited for medium to large-scale businesses
                        requiring automation and bulk messaging capabilities.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel4"}
                    onChange={handleToggle("panel4")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel4" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      // ✅ Remove border & shadow only on xs screens
                      boxShadow: {
                        xs: "none",
                        sm: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                      },
                      borderBottom: {
                        xs: "none",
                        sm: "1px solid #ddd",
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel4" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel4a-content"
                      id="panel4a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        What documents are required for onboarding?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          marginBottom: "8px", // Add spacing below the heading
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        You'll need:
                      </Typography>

                      <ul
                        style={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          paddingLeft: "20px", // Indentation for the bullet points
                          margin: "0", // Remove default margin
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        <li>
                          GST Number (or MSME Certificate if GST is not
                          available)
                        </li>
                        <li>A verified business name</li>
                        <li>Facebook Business Manager account</li>
                        <li>A phone number not registered on WhatsApp</li>
                      </ul>
                    </AccordionDetails>
                  </Accordion>

                  {/* <Accordion
                    expanded={expanded === "panel5"}
                    onChange={handleToggle("panel5")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel5" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel5" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel5a-content"
                      id="panel5a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Can I use my existing WhatsApp number?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        No, you need a phone number that is not already linked
                        to a personal or business WhatsApp account.
                      </Typography>
                    </AccordionDetails>
                  </Accordion> */}
                </Stack>
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    // border: "1px solid red",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{ width: { sm: "100%", xs: "90%" } }}
                  >
                    View More
                  </Button>
                </Stack>
              </Stack>
            </Stack>
            {/* 🔹 Vertical Divider */}
            <Box
              sx={{
                width: "1px",
                backgroundColor: "#7A7A7A", // Light gray line
                marginX: "20px", // Optional spacing
              }}
            />

            <Stack
              sx={{ width: { sm: "50%", xs: "100%" }, marginBottom: "40px" }}
            >
              <Stack sx={{ gap: 2 }}>
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    marginLeft: { xs: "16px", sm: "0px" },
                  }}
                >
                  <Stack
                    sx={{
                      fontSize: {
                        xl: "20px",
                        lg: "20px",
                        sm: "20px",
                        xs: "16px",
                      },
                      fontWeight: 400,
                      color: "var(--color-gray-400)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    INFORMATION ABOUT US
                  </Stack>
                  <Stack
                    sx={{
                      fontSize: {
                        xl: "20px",
                        lg: "20px",
                        sm: "20px",
                        xs: "16px",
                      },
                      fontWeight: 600,
                      color: "rgb(0, 0, 0)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    CONTACT US FOR ANY QUESTIONS
                  </Stack>
                </Stack>
                <Stack
                  spacing={2}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    // border: "1px solid red",
                  }}
                >
                  <Stack spacing={2} sx={{ width: { sm: "100%", xs: "90%" } }}>
                    {/* Row 1: Name & Email */}
                    <Stack
                      direction={{
                        xs: "column",
                        sm: "row",
                      }}
                      spacing={2}
                      width="100%"
                    >
                      <TextField
                        label="Your Name"
                        fullWidth
                        sx={{ width: { xs: "100%", sm: "50%" } }}
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                      />
                      <TextField
                        label="Your Email"
                        fullWidth
                        sx={{ width: { xs: "100%", sm: "50%" } }}
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                      />
                    </Stack>

                    {/* Row 2: Phone Number & Company */}
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={2}
                      width="100%"
                    >
                      <TextField
                        label="Phone Number"
                        fullWidth
                        sx={{ width: { xs: "100%", sm: "50%" } }}
                        value={formData.phone}
                        onChange={(e) =>
                          setFormData({ ...formData, phone: e.target.value })
                        }
                      />
                      <TextField
                        label="Company"
                        fullWidth
                        sx={{ width: { xs: "100%", sm: "50%" } }}
                        value={formData.company}
                        onChange={(e) =>
                          setFormData({ ...formData, company: e.target.value })
                        }
                      />
                    </Stack>

                    {/* Row 3: Your Message */}
                    <TextField
                      label="Your Message"
                      fullWidth
                      multiline
                      rows={6}
                      value={formData.message}
                      onChange={(e) =>
                        setFormData({ ...formData, message: e.target.value })
                      }
                    />
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    // border: "1px solid red",
                  }}
                >
                  <Button
                    variant="outlined"
                    sx={{ width: { sm: "100%", xs: "90%" } }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          <Stack
            sx={{
              width: {
                xl: "72%",
                lg: "80%",
                md: "90%",
                sm: "96%",
                xs: "100%",
              },
            }}
          >
            <Stack
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "column" },
                // border: "1px solid red",
                marginBottom: "40px",
              }}
            >
              <Stack
                sx={{
                  //   border: "1px solid blue",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: {
                    xl: "40px",
                    lg: "40px",
                    sm: "32px",
                    xs: "16px",
                  },
                  fontWeight: 600,
                  color: "rgb(0, 0, 0)",
                  lineHeight: "31px",
                  fontFamily:
                    "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  marginTop: "40px",
                  marginBottom: "40px",
                }}
              >
                Contact with us
              </Stack>
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: { sm: "row", xs: "column" },
                  justifyContent: "space-between",
                  //   border: "1px solid red",
                  width: "100%",
                  gap: 2,
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: { sm: "33%", xs: "100%" },
                    border: "1px solid #ddd",
                    gap: 1,
                    borderRadius: "8px",
                    padding: 1,
                  }}
                >
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <FaLocationDot style={{ fontSize: "32px" }} />
                  </Stack>
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      fontSize: {
                        xl: "24px",
                        lg: "24px",
                        sm: "20px",
                        xs: "16px",
                      },
                      fontWeight: 400,
                      color: "rgb(0, 0, 0)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    We're at
                  </Stack>
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      fontSize: {
                        sm: "16px",
                        xs: "16px",
                      },
                      fontWeight: 400,
                      color: "rgb(61, 61, 61)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      textAlign: "center",
                    }}
                  >
                    R/O 18/10 Radhika Nagar, Supela, Bhilai -490023,
                    Chhattisgarh
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: { sm: "33%", xs: "100%" },
                    border: "1px solid #ddd",
                    gap: 1,
                    borderRadius: "8px",
                    padding: 1,
                  }}
                >
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <FaPhoneAlt style={{ fontSize: "32px" }} />
                  </Stack>
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      fontSize: {
                        xl: "24px",
                        lg: "24px",
                        sm: "20px",
                        xs: "16px",
                      },
                      fontWeight: 400,
                      color: "rgb(0, 0, 0)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    Contact Us (10 AM - 7 PM)
                  </Stack>
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      fontSize: {
                        sm: "16px",
                        xs: "16px",
                      },
                      fontWeight: 400,
                      color: "rgb(61, 61, 61)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    Manager: +91721 807 7730
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: { sm: "33%", xs: "100%" },
                    border: "1px solid #ddd",
                    gap: 1,
                    borderRadius: "8px",
                    padding: 1,
                  }}
                >
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <MdEmail style={{ fontSize: "32px" }} />
                  </Stack>
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      fontSize: {
                        xl: "24px",
                        lg: "24px",
                        sm: "20px",
                        xs: "16px",
                      },
                      fontWeight: 400,
                      color: "rgb(0, 0, 0)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    Email Us
                  </Stack>
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      fontSize: {
                        sm: "16px",
                        xs: "16px",
                      },
                      fontWeight: 400,
                      color: "rgb(61, 61, 61)",
                      lineHeight: "31px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    info@atmikbharat.com
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        {/* <BlogcardSection /> */}
        {/* <CommentSection /> */}
        <CertificateCard />
      </main>
      <Footer onFAQClick={scrollToFAQ} />{" "}
    </>
  );
};

export default Contactus;
